import { atom } from "recoil"

export const refreshConfirmScreenState = atom<number>({
  key: "atoms/organization/refreshConfirmScreenState",
  default: 0,
})
